import {TimeSpan} from "./utils/time_span/time-span";
import {Check} from "./utils/type-checking/type-checking";

export {TimeSpan, Check};